import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    CardBody,
    Card,
    Alert,
    Container,
    Input,
    Label,
    Form,
    FormFeedback,
    InputGroup,
    InputGroupText,
    Tooltip
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { registerUser, apiError } from "../../store/actions";
import { useSelector, useDispatch } from "react-redux";
import { RegistrationData } from "../../api/RegistrationService";
import { getCountry, getStateByCountryId } from "../../api/countryService";
import { Link } from "react-router-dom";
import { createSelector } from "reselect";
import "../../assets/css/register.css"
import { Eye, EyeOff } from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import regBg from '../../assets/images/login_reg/login_bg3.jpg';

const Register = () => {
    document.title = "Register";

    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const togglePassword = () => setShowPassword((prev) => !prev);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);

    const handleChange = (event) => {
        setCountries(event.target.value);
    };
    const registerpage = createSelector(
        (state) => state.account,
        (state) => ({
            user: state.user,
            registrationError: state.registrationError,
        })
    );
    const { user, registrationError } = useSelector(registerpage);
    const isGlobalSubmitting = useRef(false);

    const [tooltipOpen, setTooltipOpen] = useState({});

    const toggleTooltip = (id) => {
        setTooltipOpen((prev) => ({ ...prev, [id]: !prev[id] }));
    };


    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            firstName: "",
            lastName: "",
            companyName: "",
            username: "",
            password: "",
            email: "",
            phone: "",
            businessType: "",
            address: "",
            country: "",
            state: "",
            city: "",
            zipCode: "",
            termsAccepted: false,
        },

        validationSchema: Yup.object({
            firstName: Yup.string().required("Please enter your First Name"),
            lastName: Yup.string().required("Please enter your Last Name"),
            companyName: Yup.string().required("Please enter your Company Name"),
            username: Yup.string().required("Please enter your Username"),
            password: Yup.string().required("Please enter your Password"),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref("password"), null], "Passwords must match")
                .required("Please confirm your password"),
            confirmPassword: Yup.string()
                .required("Please confirm your Password")
                .oneOf([Yup.ref("password"), null], "Passwords must match"),
            email: Yup.string()
                .email("Invalid email format")
                .required("Please enter your Email"),
            phone: Yup.string()
                .required("Please enter your Phone Number")
                .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
            businessType: Yup.string().required("Please select your Business Type"),
            // address: Yup.string().required("Please enter your Address"),
            country: Yup.string().required("Please select your Country"),
            //state: Yup.string().required("Please enter your State"),
            city: Yup.string().required("Please enter your City"),
            zipCode: Yup.string()
                .required("Please enter your Zip Code")
                .matches(/^[0-9]{5,6}$/, "Invalid Zip Code"),
            termsAccepted: Yup.bool().oneOf(
                [true],
                "You must accept Terms and Conditions"
            ),
        }),

        onSubmit: async (values, { setSubmitting, resetForm }) => {
            // prevent double-submit
            const payload = {
                FirstName: values.firstName,
                LastName: values.lastName,
                CompanyName: values.companyName,
                Email: values.email,
                MobileNo: values.phone,
                PhoneNo: "",
                Username: values.username,
                Password: values.password,
                Address: values.address,
                Country_ID: values.country?.toString(),
                State_ID: values.state?.toString(),
                City: values.city,
                ZipCode: values.zipCode,
                BusinessType: values.businessType
            };
            try {
                console.log("Registration Payload:", payload);
                const response = await RegistrationData(payload);
                console.log("Registration API Response:", response);

                if (response?.Message?.[0]?.RETURNCODE === "1") {
                    toast.success(response.Message[0].RETURNMESSAGE || "Registration successful!");
                    resetForm();
                    // Optionally navigate to login
                    // props.router.navigate("/login");
                } else {
                    toast.error(response?.Message?.[0]?.RETURNMESSAGE || "Registration failed");
                }
            } catch (error) {
                console.error("Registration API Error:", error);
                toast.error("Registration failed. Please try again.");
            } finally {
                setSubmitting(false);
                isGlobalSubmitting = false;
            }
        }
    });
    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await getCountry(); // Assuming this returns a list of countries
                setCountries(response || []);
            } catch (error) {
                toast.error("Error fetching countries:", error);
            }
        };

        fetchCountries();
    }, []);
    return (
        <div
            className="bg-pattern d-flex flex-column"
            style={{ backgroundImage: `url(${regBg})` }}
        >
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                draggable
                theme="colored"
            />
            {/* ... options ... */}
            {/* <div className="bg-overlay"></div> */}

            {/* Main form area */}
            <div className="account-pages flex-grow-1 pb-5 main-background">
                <Container>
                    <Row className="justify-content-center ">
                        <Col lg={6} md={8} xl={6}>
                            <Card className="mt-5">
                                <CardBody className="p-4 register-background" >
                                    <div className="text-center mb-1 d-flex justify-content-center align-items-center flex-wrap gap-2">
                                        <h4 className="mb-0 fw-semibold hover-text">
                                            Unlock Luxury
                                        </h4>
                                        <p>Sign up to explore our curated collection stay ahead of latest trends in fine jewelry</p>
                                    </div>
                                    <Form className="form-horizontal" onSubmit={validation.handleSubmit}
                                    >
                                        {user && (
                                            <Alert color="success">
                                                User Registered Successfully
                                            </Alert>
                                        )}
                                        {registrationError && (
                                            <Alert color="danger">
                                                <div>{registrationError}</div>
                                            </Alert>
                                        )}
                                        {/* First Name / Last Name */}
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="firstName">First Name</Label>
                                                    <Input
                                                        id="firstName"
                                                        name="firstName"
                                                        type="text"
                                                        placeholder="Enter First Name"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.firstName}
                                                        invalid={validation.touched.firstName && !!validation.errors.firstName}
                                                    />
                                                    <FormFeedback>{validation.errors.firstName}</FormFeedback>
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="lastName">Last Name</Label>
                                                    <Input
                                                        id="lastName"
                                                        name="lastName"
                                                        type="text"
                                                        placeholder="Enter Last Name"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.lastName}
                                                        invalid={validation.touched.lastName && !!validation.errors.lastName}
                                                    />
                                                    <FormFeedback>{validation.errors.lastName}</FormFeedback>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="companyName">Company Name</Label>
                                                    <Input
                                                        id="companyName"
                                                        name="companyName"
                                                        type="text"
                                                        placeholder="Enter Company Name"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.companyName}
                                                        invalid={validation.touched.companyName && !!validation.errors.companyName}
                                                    />
                                                    <FormFeedback>{validation.errors.companyName}</FormFeedback>
                                                </div>
                                            </Col>


                                        </Row>

                                        {/* Username */}
                                        <Row>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="username">Username</Label>
                                                    <Input
                                                        id="username"
                                                        name="username"
                                                        type="text"
                                                        placeholder="Enter Username"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.username}
                                                        invalid={validation.touched.username && !!validation.errors.username}
                                                    />
                                                    <FormFeedback>{validation.errors.username}</FormFeedback>
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="password">Password</Label>
                                                    <InputGroup>
                                                        <Input
                                                            id="password"
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={showPassword ? "text" : "password"}
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={validation.touched.password && !!validation.errors.password}
                                                        />
                                                        <InputGroupText
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            style={{
                                                                cursor: "pointer",
                                                                backgroundColor: "#f3f3f4",
                                                                borderLeft: "none",
                                                            }}
                                                        >
                                                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                                        </InputGroupText>
                                                        {validation.touched.password && validation.errors.password && (
                                                            <FormFeedback>{validation.errors.password}</FormFeedback>
                                                        )}
                                                    </InputGroup>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="confirmPassword">Confirm Password</Label>
                                                    <InputGroup>
                                                        <Input
                                                            id="confirmPassword"
                                                            name="confirmPassword"
                                                            value={validation.values.confirmPassword || ""}
                                                            type={showConfirmPassword ? "text" : "password"}
                                                            placeholder="Confirm Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={validation.touched.confirmPassword && !!validation.errors.confirmPassword}
                                                        />
                                                        <InputGroupText
                                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                            style={{
                                                                cursor: "pointer",
                                                                backgroundColor: "#f3f3f4",
                                                                borderLeft: "none",
                                                            }}
                                                        >
                                                            {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                                        </InputGroupText>
                                                        {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                                                            <FormFeedback type="invalid">
                                                                <div>{validation.errors.confirmPassword}</div>
                                                            </FormFeedback>
                                                        ) : null}
                                                    </InputGroup>

                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="email">Email</Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        type="email"
                                                        placeholder="Enter Email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email}
                                                        invalid={validation.touched.email && !!validation.errors.email}
                                                    />
                                                    <FormFeedback>{validation.errors.email}</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Phone */}
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="phone">Mobile Number</Label>
                                                    <Input
                                                        id="phone"
                                                        name="phone"
                                                        type="number"
                                                        placeholder="Enter Phone Number"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.phone}
                                                        invalid={validation.touched.phone && !!validation.errors.phone}
                                                    />
                                                    <FormFeedback>{validation.errors.phone}</FormFeedback>
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="businessType">Business Type</Label>
                                                    <Input
                                                        id="businessType"
                                                        name="businessType"
                                                        type="select"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.businessType}
                                                        invalid={validation.touched.businessType && !!validation.errors.businessType}
                                                    >
                                                        <option value="">Select Business Type</option>
                                                        <option value="Wholesaler">Wholesaler</option>
                                                        <option value="Retailer">Retailer</option>
                                                        <option value="Others">Others</option>
                                                    </Input>
                                                    <FormFeedback>{validation.errors.businessType}</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Address */}
                                        <div className="mb-2">
                                            <Label className="form-label-login" htmlFor="address">Address</Label>
                                            <Input
                                                id="address"
                                                name="address"
                                                type="textarea"
                                                placeholder="Enter Address"
                                                onChange={validation.handleChange}
                                                //onBlur={validation.handleBlur}
                                                value={validation.values.address}
                                            // invalid={validation.touched.address && !!validation.errors.address}
                                            />
                                            {/* <FormFeedback>{validation.errors.address}</FormFeedback> */}
                                        </div>

                                        {/* Country / State */}
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="country">Country</Label>
                                                    <Select
                                                        inputId="country"
                                                        name="country"
                                                        options={Array.isArray(countries?.Countries)
                                                            ? countries.Countries.map(country => ({
                                                                value: country.COUNTRY_ID,
                                                                label: country.COUNTRYNAME
                                                            }))
                                                            : []}
                                                        isSearchable
                                                        isClearable
                                                        placeholder="Select Country"
                                                        value={
                                                            countries?.Countries?.find(r => r.COUNTRY_ID === validation.values.country)
                                                                ? {
                                                                    value: validation.values.country,
                                                                    label: countries.Countries.find(r => r.COUNTRY_ID === validation.values.country).COUNTRYNAME
                                                                }
                                                                : null
                                                        }
                                                        onChange={async (selectedOption) => {
                                                            const selectedCountryId = selectedOption ? selectedOption.value : "";
                                                            validation.setFieldValue("country", selectedOption ? selectedOption.value : "");
                                                            validation.setFieldValue("state", ""); // reset state field when country changes
                                                            if (selectedCountryId) {
                                                                try {
                                                                    const response = await getStateByCountryId({ IntCountyID: selectedCountryId });
                                                                    if (response?.States) {
                                                                        setStates(response.States);
                                                                    } else {
                                                                        setStates([]);
                                                                    }
                                                                } catch (error) {
                                                                    console.error("Error fetching states:", error);
                                                                    setStates([]);
                                                                }
                                                            } else {
                                                                setStates([]);
                                                            }
                                                        }}
                                                        onBlur={() => validation.setFieldTouched("country", true)}
                                                        className={validation.touched.country && validation.errors.country ? "is-invalid" : ""}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                backgroundColor: "#f3f3f4",
                                                                border: "none"
                                                            })
                                                        }}
                                                    />
                                                    {validation.touched.country && validation.errors.country && (
                                                        <div className="invalid-feedback">{validation.errors.country}</div>
                                                    )}
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="state">State</Label>
                                                    <Select
                                                        inputId="state"
                                                        name="state"
                                                        options={Array.isArray(states)
                                                            ? states.map(state => ({
                                                                value: state.STATE_ID,
                                                                label: state.STATENAME
                                                            }))
                                                            : []}
                                                        isSearchable
                                                        isClearable
                                                        placeholder="Select State"
                                                        value={
                                                            states.find(r => r.STATE_ID === validation.values.state)
                                                                ? {
                                                                    value: validation.values.state,
                                                                    label: states.find(r => r.STATE_ID === validation.values.state).STATENAME
                                                                }
                                                                : null
                                                        }
                                                        onChange={(selectedOption) => {
                                                            validation.setFieldValue("state", selectedOption ? selectedOption.value : "");
                                                        }}
                                                        onBlur={() => validation.setFieldTouched("state", true)}
                                                        className={validation.touched.state && validation.errors.state ? "is-invalid" : ""}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                backgroundColor: "#f3f3f4",
                                                                border: "none"
                                                            })
                                                        }}
                                                    />
                                                    {validation.touched.state && validation.errors.state && (
                                                        <div className="invalid-feedback">{validation.errors.state}</div>
                                                    )}

                                                    <FormFeedback>{validation.errors.state}</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* City / Zip */}
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="city">City</Label>
                                                    <Input
                                                        id="city"
                                                        name="city"
                                                        type="text"
                                                        placeholder="Enter City"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.city}
                                                        invalid={validation.touched.city && !!validation.errors.city}
                                                    />
                                                    <FormFeedback>{validation.errors.city}</FormFeedback>
                                                </div>
                                            </Col>

                                            <Col md={6}>
                                                <div className="mb-2">
                                                    <Label className="form-label-login" htmlFor="zipCode">Zip Code</Label>
                                                    <Input
                                                        id="zipCode"
                                                        name="zipCode"
                                                        type="text"
                                                        placeholder="Enter Zip Code"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.zipCode}
                                                        invalid={validation.touched.zipCode && !!validation.errors.zipCode}
                                                    />
                                                    <FormFeedback>{validation.errors.zipCode}</FormFeedback>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Terms */}
                                        {/*<div className="form-check mb-2">*/}
                                        {/*    <Input*/}
                                        {/*        id="termsAccepted"*/}
                                        {/*        type="checkbox"*/}
                                        {/*        className="form-check-input"*/}
                                        {/*        name="termsAccepted"*/}
                                        {/*        onChange={validation.handleChange}*/}
                                        {/*        checked={validation.values.termsAccepted}*/}
                                        {/*        invalid={validation.touched.termsAccepted && !!validation.errors.termsAccepted}*/}
                                        {/*    />*/}
                                        {/*    <Label className="form-label-login form-check-label fw-normal terms-condition" htmlFor="termsAccepted">*/}
                                        {/*        I Accept <Link id="qa-terms" to="#" className="text-primary">Terms and Conditions</Link>*/}
                                        {/*    </Label>*/}
                                        {/*    <li style={{ listStyle: "none" }}>*/}
                                        {/*        <Link*/}
                                        {/*            id="qa-terms"*/}
                                        {/*            to="/terms"*/}
                                        {/*            target="_blank"*/}
                                        {/*            className="text-primary"*/}
                                        {/*            onClick={(e) => e.preventDefault()} // Prevent navigation if needed*/}
                                        {/*        >*/}
                                        {/*            */}{/* I Accept Terms and Conditions */}
                                        {/*        </Link>*/}

                                        {/*        <Tooltip*/}
                                        {/*            fade={true}*/}
                                        {/*            placement="top"*/}
                                        {/*            isOpen={!!tooltipOpen["qa-terms"]}*/}
                                        {/*            target="qa-terms"*/}
                                        {/*            toggle={() => toggleTooltip("qa-terms")}*/}
                                        {/*        >*/}
                                        {/*            Available Soon*/}
                                        {/*        </Tooltip>*/}
                                        {/*    </li>*/}

                                        {/*    {validation.touched.termsAccepted && validation.errors.termsAccepted && (*/}
                                        {/*        <FormFeedback className="d-block">*/}
                                        {/*            {validation.errors.termsAccepted}*/}
                                        {/*        </FormFeedback>*/}
                                        {/*    )}*/}
                                        {/*</div>*/}


                                        <div className="form-check mb-2">
                                            <Input
                                                id="termsAccepted"
                                                type="checkbox"
                                                className="form-check-input"
                                                name="termsAccepted"
                                                onChange={validation.handleChange}
                                                checked={validation.values.termsAccepted}
                                                invalid={validation.touched.termsAccepted && !!validation.errors.termsAccepted}
                                            />
                                            <Label
                                                className="form-label-login form-check-label fw-normal terms-condition"
                                                htmlFor="termsAccepted"
                                            >
                                                I Accept{' '}
                                                <Link
                                                    id="qa-terms"
                                                    to="/terms-condition"
                                                    className="text-primary"
                                                >
                                                    Terms and Conditions
                                                </Link>
                                            </Label>

                                            {validation.touched.termsAccepted && validation.errors.termsAccepted && (
                                                <FormFeedback className="d-block">
                                                    {validation.errors.termsAccepted}
                                                </FormFeedback>
                                            )}
                                        </div>


                                        {/* Terms */}

                                        {/* Submit */}
                                        <div className="d-grid mt-4">
                                            <button
                                                className="btn btn-primary waves-effect waves-light"
                                                disabled={validation.isSubmitting}
                                                type="submit"
                                            >
                                                Register
                                            </button>
                                        </div>
                                        {/* Footer links */}
                                        <div className="mt-4 text-center">
                                            <p className="text-muted">
                                                <a
                                                    id="qa-forgot-password"
                                                    href="/forget-password"
                                                >
                                                    Forgot Password?
                                                </a>
                                            </p>
                                            <p className="text-muted">
                                                Already have an account?{" "}
                                                <Link to="/login" className="fw-medium text-primary"
                                                >
                                                    Login
                                                </Link>
                                            </p>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};
export default Register;

